<template>
  <BModal
    id="modal-refund-balance"
    hide-footer
    hide-header
    :centered="true"
    content-class="rounded-lg"
  >
    <div class="text-center p-1">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Konfirmasi"
        class="mx-auto"
        width="80px"
      >

      <div class="font-semibold text-[18px] text-[#333333] my-2">
        Konfirmasi Pengembalian Saldo
      </div>

      <div class="mb-2 text-[#6b7280]">
        <p>Saldo akan dikembalikan ke akun partner dan pengajuan akan dibatalkan.</p>
      </div>

      <div class="my-2 text-[#333333]">
        <span>Nominal Pengembalian : </span>
        <span class="font-semibold">{{ IDR(refund) }}</span>
      </div>

      <div class="flex flex-row gap-6">
        <BButton
          variant="outline-primary"
          class="rounded grow"
          @click="$bvModal.hide('modal-refund-balance')"
        >
          Batal
        </BButton>

        <BButton
          variant="primary"
          class="rounded grow"
          @click="confirmRefund()"
        >
          Setujui
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
import { IDR } from '@/libs/currency'

export default {
  name: 'ModalRefundBalance',
  props: {
    // Nominal pengembalian saldo (dalam angka atau string angka)
    refund: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      IDR,
    }
  },
  methods: {
    confirmRefund() {
      this.$emit('confirm-refund')
      this.$bvModal.hide('modal-refund-balance')
      setTimeout(() => this.$router.push({ name: 'komads-setup-whitelisted' }), 1000)
    },
  },
}
</script>
